<template>
  <div class="history-panel" v-loading="loading">
    <button
      type="button"
      class="history-panel__upload"
      @click="goUpload"
    >
      <svg
        class="history-panel__upload-icon"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect
          x="2.5"
          y="3.5"
          width="15"
          height="13"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          stroke-width="1.4"
        />
        <path
          d="M5 6.5h1.2M5 10h1.2M5 13.5h1.2M13.8 6.5H15M13.8 10H15M13.8 13.5H15"
          stroke="currentColor"
          stroke-width="1.4"
          stroke-linecap="round"
        />
        <circle cx="10" cy="10" r="3.2" fill="none" stroke="currentColor" stroke-width="1.4" />
        <path d="M9 8.6v2.8l2.4-1.4z" fill="currentColor" />
      </svg>
      <span>新上传参考视频/音频</span>
    </button>

    <h3 class="history-panel__subtitle">历史识别记录</h3>
    <div v-if="!loading && !historyList.length" class="history-panel__empty">
      暂无识别记录
    </div>
    <div v-else class="history-panel__list">
      <div
        v-for="group in historyList"
        :key="group.date"
        class="history-panel__group"
      >
        <div class="history-panel__date">{{ group.date }}</div>
        <div
          v-for="item in group.records"
          :key="item.log_id"
          class="history-panel__record"
          :class="{ 'is-active': item.log_id === activeLogId }"
          :title="item.file_name"
          @click="goDetail(item)"
        >
          {{ item.file_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSmlList } from '@/api/similarAI'

export default {
  name: 'HistoryPanel',
  data() {
    return {
      loading: false,
      historyList: []
    }
  },
  computed: {
    activeLogId() {
      return this.$route.params.log_id || ''
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await fetchSmlList({})
        const data = (res && res.data) || {}
        this.historyList = Object.keys(data)
          .sort((a, b) => (a < b ? 1 : -1))
          .map((date) => ({
            date,
            records: data[date] || []
          }))
      } catch (err) {
        console.error(err)
        this.historyList = []
      } finally {
        this.loading = false
      }
    },
    goUpload() {
      if (this.$route.path === '/similar-music') return
      this.$router.push({ path: '/similar-music' })
    },
    goDetail(item) {
      if (!item || !item.log_id) return
      const path = `/similar-music/detail/${item.log_id}`
      if (this.$route.path === path) return
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="scss" scoped>
.history-panel {
  width: 100%;
  height: 100%;
  padding: 16px 16px 20px;
  box-sizing: border-box;
  background: #fff;
  overflow-y: auto;

  &__upload {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin: 0 0 16px;
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    background: #f5f5f5;
    color: #666;
    font-size: 14px;
    line-height: 1.4;
    text-align: left;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;

    &:hover {
      color: #e52a0d;
      background: rgba(229, 42, 13, 0.06);
    }
  }

  &__upload-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &__subtitle {
    margin: 0 0 16px;
    font-size: 13px;
    font-weight: 400;
    color: #999;
    line-height: 1.4;
  }

  &__empty {
    font-size: 13px;
    color: #999;
    line-height: 1.5;
  }

  &__group {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__date {
    margin-bottom: 8px;
    font-size: 13px;
    color: #999;
    line-height: 1.4;
  }

  &__record {
    padding: 6px 0;
    font-size: 14px;
    color: #1a1a1a;
    line-height: 1.5;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: #e52a0d;
    }

    &.is-active {
      color: #e52a0d;
      font-weight: 600;
    }
  }
}
</style>
